import { PluginKey } from '@tiptap/pm/state';

export const COLLAPSIBLE_LIST_SETTINGS_MODAL_ID = 'COLLAPSIBLE_LIST.settings';

export const collapsibleStateManagerPlugin = new PluginKey('collapsibleStateManager');
